import { inject, Injectable } from '@angular/core';
import { SwitchingProfileDisplay } from '@com-delta-idp/mnx-capability-profile-selector-ui';
import {
  checkStringValueNull,
  CLEAR_GIF_IMAGE,
  CookieHelperService,
  getAuxiliaryNavigation,
  HeaderFooterMachCore,
  PROFILE_SELECTOR,
  ProfileSelectorAem
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { SwitchingAccountService } from '../../services/switching-account/switching-account.service';

@Injectable({
  providedIn: 'root'
})
export class SwitchProfileAdapterService {
  switchingAccount = inject(SwitchingAccountService);
  cookieHelper = inject(CookieHelperService);

  getContent(content: HeaderFooterMachCore): SwitchingProfileDisplay {
    return {
      displayTravelType: this.getDisplayTravelType(content),
      clearGifImage: this.getImage(content)
    };
  }

  getDisplayTravelType(content: HeaderFooterMachCore): string {
    const profileSelector = getAuxiliaryNavigation(
      content,
      PROFILE_SELECTOR
    ) as ProfileSelectorAem;
    const corpCookie: string = this.cookieHelper.getCookieValue('corp') ?? '';
    this.switchingAccount.setInitialBusinessType(corpCookie);
    if (this.switchingAccount.businessUser) {
      return checkStringValueNull(profileSelector?.businessLoginDisplayText);
    } else {
      return checkStringValueNull(profileSelector?.personalLoginDisplayText);
    }
  }

  getImage(content: HeaderFooterMachCore): string {
    return content.header?.clearGifImage ?? CLEAR_GIF_IMAGE;
  }
}
